export class AppConstants {
	/**
		* The name that is used for the returnUrl queryParam
		*/
	static RETURN_URL                  = 'returnUrl';
	static FILTER_BAR_CONTEXT_PROPERTY = 'navFilterBar';
}
